/**
 * @file index.js
 * @description Punto de entrada principal de la aplicación React.
 * Renderiza el componente `App` en el elemento 'root' del DOM.
 * Importa estilos globales de Bootstrap y `index.css`.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
// Sistema de color: tokens + puente hacia las variables de Bootstrap. Va DESPUÉS
// de bootstrap.min.css a propósito. ⚠ Temporal mientras se elige la paleta.
import './theme/tokens.css';
import './theme/bootstrap-bridge.css';
import './theme/swal-theme.css';
import 'react-phone-number-input/style.css';
import './phone-input-custom.css';
import './i18n'; // Importar la configuración de i18n
import { initAnalytics } from './services/analytics';

// PostHog: analítica de comportamiento + error tracking (tarea 004). Toda la configuración
// (opt-out por defecto, error tracking, identidad) vive en src/services/analytics.js.
initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);